export default "__VITE_ASSET__CqFUO8zK__"